import { EntityDescription, TypeDescriptionService, Metadata } from '../Api/interfaces';

export default class DummyTypeService implements TypeDescriptionService {
  private static instance: DummyTypeService;

  private metaData: Metadata;

  private constructor() {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const data = require('../Static/Metadata.json');
    this.metaData = data as Metadata;
  }

  public async getDescriptor(typeName: string): Promise<EntityDescription> {
    return this.metaData.entityDescriptions.find((e) => e.typeName.toLowerCase() === typeName.toLowerCase());
  }

  public async getDescriptors(): Promise<EntityDescription[]> {
    return this.metaData.entityDescriptions.filter((x) => !x.typeName.startsWith('C_'));
  }

  public async getMetadata(): Promise<Metadata> {
    return this.metaData;
  }

  public static getInstance(): DummyTypeService {
    if (!DummyTypeService.instance) {
      DummyTypeService.instance = new DummyTypeService();
    }
    return DummyTypeService.instance;
  }
}
